import { Http } from "@/util";

export function getPushMessageList(param) {
  return Http.post("/admin/push_message/list", param);
}

export function sendMessage(param) {
  return Http.post("/admin/push_message/push/message", param);
}
